import produce from 'immer'

import {
  EVENTS_LOAD,
  EVENTS_RELOAD,
  EVENTS_RELOAD_SUCCESS,
  EVENTS_LOAD_SUCCESS,
  EVENTS_LOAD_FAILURE,
  EVENTS_COUNT_LOAD,
  EVENTS_COUNT_RELOAD,
  EVENTS_COUNT_LOAD_SUCCESS,
  EVENTS_COUNT_LOAD_FAILURE,
  PROJECT_TAGS_LOAD,
  PROJECT_TAGS_LOAD_SUCCESS,
  PROJECT_TAGS_LOAD_FAILURE,
  PROJECT_TAG_RENAME,
  PROJECT_TAG_RENAME_SUCCESS,
  PROJECT_TAG_RENAME_FAILURE,
  PROJECT_TAG_CREATE,
  PROJECT_TAG_CREATE_SUCCESS,
  PROJECT_TAG_CREATE_FAILURE,
  ASSIGN_RECORDS,
  ASSIGN_RECORDS_FAILURE,
  ASSIGN_RECORDS_SUCCESS,
  UNASSIGN_RECORDS,
  UNASSIGN_RECORDS_FAILURE,
  UNASSIGN_RECORDS_SUCCESS,
  TAG_RECORDS,
  TAG_RECORDS_FAILURE,
  TAG_RECORDS_SUCCESS,
  UNTAG_RECORDS,
  UNTAG_RECORDS_FAILURE,
  UNTAG_RECORDS_SUCCESS,
  DISMISS_EVENTS,
  DISMISS_EVENTS_FAILURE,
  DISMISS_EVENTS_SUCCESS,
  EVENTS_FILTER_LOAD,
  EVENTS_FILTER_LOAD_SUCCESS,
  EVENTS_FILTER_LOAD_FAILURE
} from './actions'

const DEFAULT_MODULE_STATE = {
  loading: false,
  error: null,
  items: [],
  continuationToken: null,
  count: 0,
  loadingCount: true,
  errorCount: null
}
const DEFAULT_MODULE_FILTER_STATE = {
  loading: false,
  error: null,
  description: [],
  tradeContractor: [],
  wasteCarrier: [],
  subcontractor: [],
  supplier: [],
  assigneeIds: []
}

const initialState = {
  other: DEFAULT_MODULE_STATE,
  waste: DEFAULT_MODULE_STATE,
  wasteFilter: DEFAULT_MODULE_FILTER_STATE,
  delivery: DEFAULT_MODULE_STATE,
  deliveryFilter: DEFAULT_MODULE_FILTER_STATE,
  submission: DEFAULT_MODULE_STATE,
  submissionFilter: DEFAULT_MODULE_FILTER_STATE,
  projectTags: {},
  tagRename: {
    loading: false,
    error: null
  },
  tagCreate: {
    loading: false,
    error: null
  },
  assign: {
    loading: false,
    error: null
  },
  unassign: {
    loading: false,
    error: null
  },
  tag: {
    loading: false,
    error: null
  },
  untag: {
    loading: false,
    error: null
  },
  dismissal: {
    loading: false,
    error: null
  }
}

export const reducer = (state = initialState, action) => {
  let { moduleName } = action
  if (moduleName) {
    moduleName = moduleName.toLowerCase()
  } else {
    moduleName = 'submission'
  }

  return produce(state, draft => {
    const projectKey = `${action.accountId}_${action.projectId}`

    switch (action.type) {
      case EVENTS_LOAD: {
        draft[moduleName].loading = true
        draft[moduleName].error = null
        return
      }
      case EVENTS_RELOAD: {
        draft[moduleName].error = null
        return
      }
      case EVENTS_RELOAD_SUCCESS: {
        if (action.events.length >= draft[moduleName].items.length) {
          draft[moduleName].items = action.events
          draft[moduleName].continuationToken = action.continuationToken
        }
        return
      }
      case EVENTS_LOAD_SUCCESS: {
        draft[moduleName].loading = false
        draft[moduleName].error = null

        draft[moduleName].items = action.events
        draft[moduleName].continuationToken = action.continuationToken
        return
      }
      case EVENTS_LOAD_FAILURE: {
        draft[moduleName].loading = false
        draft[moduleName].error = action.error
        return
      }
      case EVENTS_COUNT_LOAD: {
        draft[moduleName].loadingCount = true
        draft[moduleName].errorCount = null
        return
      }
      case EVENTS_COUNT_RELOAD: {
        draft[moduleName].errorCount = null
        return
      }
      case EVENTS_COUNT_LOAD_SUCCESS: {
        draft[moduleName].loadingCount = false
        draft[moduleName].errorCount = null

        draft[moduleName].count = action.count.total
        draft[moduleName].allEvents = action.count.eventCountEntries
        return
      }
      case EVENTS_COUNT_LOAD_FAILURE: {
        draft[moduleName].loadingCount = false
        draft[moduleName].errorCount = action.error
        return
      }
      case PROJECT_TAGS_LOAD: {
        draft.projectTags[projectKey] = {
          ...(draft.projectTags[projectKey] || {
            items: [],
            loaded: false,
            error: null
          }),
          loading: true,
          error: null
        }
        return
      }
      case PROJECT_TAGS_LOAD_SUCCESS: {
        draft.projectTags[projectKey] = {
          loading: false,
          loaded: true,
          error: null,
          items: action.tags || []
        }
        return
      }
      case PROJECT_TAGS_LOAD_FAILURE: {
        draft.projectTags[projectKey] = {
          ...(draft.projectTags[projectKey] || {
            items: [],
            loaded: false
          }),
          loading: false,
          error: action.error
        }
        return
      }
      case PROJECT_TAG_RENAME: {
        draft.tagRename.loading = true
        draft.tagRename.error = null
        return
      }
      case PROJECT_TAG_RENAME_SUCCESS: {
        draft.tagRename.loading = false
        draft.tagRename.error = null
        return
      }
      case PROJECT_TAG_RENAME_FAILURE: {
        draft.tagRename.loading = false
        draft.tagRename.error = action.error
        return
      }
      case PROJECT_TAG_CREATE: {
        draft.tagCreate.loading = true
        draft.tagCreate.error = null
        return
      }
      case PROJECT_TAG_CREATE_SUCCESS: {
        draft.tagCreate.loading = false
        draft.tagCreate.error = null
        return
      }
      case PROJECT_TAG_CREATE_FAILURE: {
        draft.tagCreate.loading = false
        draft.tagCreate.error = action.error
        return
      }
      case ASSIGN_RECORDS: {
        draft.assign.loading = true
        draft.assign.error = null
        return
      }
      case ASSIGN_RECORDS_FAILURE: {
        draft.assign.loading = false
        draft.assign.error = action.error
        return
      }
      case ASSIGN_RECORDS_SUCCESS: {
        draft.assign.loading = false
        draft.assign.error = null
        return
      }
      case UNASSIGN_RECORDS: {
        draft.unassign.loading = true
        draft.unassign.error = null
        return
      }
      case UNASSIGN_RECORDS_FAILURE: {
        draft.unassign.loading = false
        draft.unassign.error = action.error
        return
      }
      case UNASSIGN_RECORDS_SUCCESS: {
        draft.unassign.loading = false
        draft.unassign.error = null
        return
      }
      case TAG_RECORDS: {
        draft.tag.loading = true
        draft.tag.error = null
        return
      }
      case TAG_RECORDS_FAILURE: {
        draft.tag.loading = false
        draft.tag.error = action.error
        return
      }
      case TAG_RECORDS_SUCCESS: {
        draft.tag.loading = false
        draft.tag.error = null
        return
      }
      case UNTAG_RECORDS: {
        draft.untag.loading = true
        draft.untag.error = null
        return
      }
      case UNTAG_RECORDS_FAILURE: {
        draft.untag.loading = false
        draft.untag.error = action.error
        return
      }
      case UNTAG_RECORDS_SUCCESS: {
        draft.untag.loading = false
        draft.untag.error = null
        return
      }
      case DISMISS_EVENTS: {
        draft.dismissal.loading = true
        draft.dismissal.error = null
        return
      }
      case DISMISS_EVENTS_FAILURE: {
        draft.dismissal.loading = false
        draft.dismissal.error = action.error
        return
      }
      case DISMISS_EVENTS_SUCCESS: {
        draft.dismissal.loading = false
        draft.dismissal.error = null
        return
      }
      case EVENTS_FILTER_LOAD: {
        draft[`${moduleName}Filter`].loading = true
        draft[`${moduleName}Filter`].error = null
        return
      }
      case EVENTS_FILTER_LOAD_SUCCESS: {
        draft[`${moduleName}Filter`].loading = false
        draft[`${moduleName}Filter`].error = null
        draft[`${moduleName}Filter`].description =
          action.filterOptions.description
        draft[`${moduleName}Filter`].tradeContractor =
          action.filterOptions.tradeContractor
        draft[`${moduleName}Filter`].supplier = action.filterOptions.supplier
        draft[`${moduleName}Filter`].wasteCarrier =
          action.filterOptions.wasteCarrier
        draft[`${moduleName}Filter`].subcontractor =
          action.filterOptions.subcontractor
        draft[`${moduleName}Filter`].assigneeIds =
          action.filterOptions.assigneeIds
        return
      }
      case EVENTS_FILTER_LOAD_FAILURE: {
        draft[`${moduleName}Filter`].loading = false
        draft[`${moduleName}Filter`].error = action.error
        return
      }
    }
  })
}
